import { ChartConfig } from '@/components/ui/chart'
import { z } from 'zod'

import * as React from 'react'
import { schema } from '@/pages/powerdoc-project-view'
import { useParams } from 'react-router-dom'
import { useState } from 'react'

const chartConfig = {
  desktop: {
    label: 'Desktop',
    color: 'var(--primary)',
  },
  mobile: {
    label: 'Mobile',
    color: 'var(--primary)',
  },
} satisfies ChartConfig

export function TableCellViewer({ item }: { item: z.infer<typeof schema> }) {
  return (
    <span className="text-sm font-medium underline text-foreground w-fit px-0 text-left whitespace-wrap">
      {item.title}
    </span>
  )
}
